/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDevice200Response,
  CreateDeviceRequest,
  UpdateDevice200Response,
  UpdateHardwarePreferencesRequest,
} from '../models/index';
import {
    CreateDevice200ResponseFromJSON,
    CreateDevice200ResponseToJSON,
    CreateDeviceRequestFromJSON,
    CreateDeviceRequestToJSON,
    UpdateDevice200ResponseFromJSON,
    UpdateDevice200ResponseToJSON,
    UpdateHardwarePreferencesRequestFromJSON,
    UpdateHardwarePreferencesRequestToJSON,
} from '../models/index';

export interface CreateDeviceOperationRequest {
    createDeviceRequest: CreateDeviceRequest;
}

export interface UpdateDeviceRequest {
    deviceId: string;
    createDeviceRequest: CreateDeviceRequest;
}

export interface UpdateHardwarePreferencesOperationRequest {
    deviceId: string;
    updateHardwarePreferencesRequest?: UpdateHardwarePreferencesRequest;
}

/**
 * 
 */
export class DevicesApi extends runtime.BaseAPI {

    /**
     */
    async createDeviceRaw(requestParameters: CreateDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDevice200Response>> {
        if (requestParameters['createDeviceRequest'] == null) {
            throw new runtime.RequiredError(
                'createDeviceRequest',
                'Required parameter "createDeviceRequest" was null or undefined when calling createDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/devices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeviceRequestToJSON(requestParameters['createDeviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDevice200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async createDevice(requestParameters: CreateDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDevice200Response> {
        const response = await this.createDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDeviceRaw(requestParameters: UpdateDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateDevice200Response>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling updateDevice().'
            );
        }

        if (requestParameters['createDeviceRequest'] == null) {
            throw new runtime.RequiredError(
                'createDeviceRequest',
                'Required parameter "createDeviceRequest" was null or undefined when calling updateDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/devices/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeviceRequestToJSON(requestParameters['createDeviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateDevice200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateDevice(requestParameters: UpdateDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateDevice200Response> {
        const response = await this.updateDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateHardwarePreferencesRaw(requestParameters: UpdateHardwarePreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling updateHardwarePreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/devices/hardware-preferences/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHardwarePreferencesRequestToJSON(requestParameters['updateHardwarePreferencesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateHardwarePreferences(requestParameters: UpdateHardwarePreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateHardwarePreferencesRaw(requestParameters, initOverrides);
    }

}
